import { useQuery } from "@tanstack/react-query";
import { orgBillingApi } from "@/api/org-billing-api";
import { useActiveOrg } from "@/hooks/use-active-org";
import type { Subscription } from "@/api/billing-api";

export function useOrgSubscription() {
  const { orgId } = useActiveOrg();

  const { data: subscription, isLoading, error } = useQuery<Subscription | null>({
    queryKey: ["orgSubscription", orgId],
    queryFn: () => {
      if (!orgId) return null;
      return orgBillingApi.getSubscription(orgId);
    },
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  // Mirror useSubscription's 403 → not-admin signal so call sites can read
  // isAdmin without distinguishing between hooks.
  const is403Error =
    error &&
    typeof error === "object" &&
    "response" in error &&
    (error as any).response?.status === 403;

  return {
    subscription,
    isLoading,
    error,
    isTrialing: subscription?.is_trialing,
    trialEndDate: subscription?.trial_end,
    isAdmin: !is403Error,
  };
}
